// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.ManualCodeModal_modal__oCvyE {
  z-index: 500;
  padding: 7px;
  align-items: flex-end;
}
div.ManualCodeModal_modal__wp__Sy-Cl {
  display: flex;
  flex-direction: column;
}
div.ManualCodeModal_modal__body__OfCtT {
  margin-top: 16px;
}
div.ManualCodeModal_modal__label__grWBh {
  font-weight: 400;
  font-size: var(--fz-lg);
  line-height: 114%;
}
div.ManualCodeModal_modal__input__hnf6h {
  margin-top: 7px;
}
div.ManualCodeModal_modal__input__hnf6h .input {
  height: 44px;
  padding: 3px 15px;
  font-size: var(--fz-lg);
}
div.ManualCodeModal_modal__footer__Xfxx8 {
  margin-top: 16px;
  display: flex;
  align-items: center;
}
div.ManualCodeModal_modal__footer__Xfxx8 button:first-child {
  flex: 1 1;
  padding: 12px 30px;
}
div.ManualCodeModal_modal__footer__Xfxx8 button + button {
  margin-left: 12px;
}
div.ManualCodeModal_modal__error__kB07m {
  color: var(--error);
  font-size: var(--fz-md);
  font-style: normal;
  line-height: var(--lh-md);
  transition: 0.15s;
  margin-top: 7px;
}

div.ManualCodeModal_inputFocused__pOBya {
  padding-bottom: 47px;
}`, "",{"version":3,"sources":["webpack://./src/components/Modals/ManualCodeModal/ManualCodeModal.module.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,YAAA;EACA,qBAAA;AACJ;AACI;EACI,aAAA;EACA,sBAAA;AACR;AAEI;EACI,gBAAA;AAAR;AAGI;EACI,gBAAA;EACA,uBAAA;EACA,iBAAA;AADR;AAII;EACI,eAAA;AAFR;AAKY;EACI,YAAA;EACA,iBAAA;EACA,uBAAA;AAHhB;AAQI;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;AANR;AAQQ;EACI,SAAA;EACA,kBAAA;AANZ;AASQ;EACI,iBAAA;AAPZ;AAWI;EACI,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;AATR;;AAaA;EACE,oBAAA;AAVF","sourcesContent":["div.modal {\n    z-index: 500;\n    padding: 7px;\n    align-items: flex-end;\n\n    &__wp {\n        display: flex;\n        flex-direction: column;\n    }\n\n    &__body {\n        margin-top: 16px;\n    }\n\n    &__label {\n        font-weight: 400;\n        font-size: var(--fz-lg);\n        line-height: 114%;\n    }\n\n    &__input {\n        margin-top: 7px;\n\n        :global {\n            .input {\n                height: 44px;\n                padding: 3px 15px;\n                font-size: var(--fz-lg);\n            }\n        }\n    }\n\n    &__footer {\n        margin-top: 16px;\n        display: flex;\n        align-items: center;\n\n        & button:first-child {\n            flex: 1 1;\n            padding: 12px 30px;\n        }\n\n        & button + button {\n            margin-left: 12px;\n        }\n    }\n\n    &__error {\n        color: var(--error);\n        font-size: var(--fz-md);\n        font-style: normal;\n        line-height: var(--lh-md);\n        transition: 0.15s;\n        margin-top: 7px;\n    }\n}\n\ndiv.inputFocused {\n  padding-bottom: 47px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `ManualCodeModal_modal__oCvyE`,
	"modal__wp": `ManualCodeModal_modal__wp__Sy-Cl`,
	"modal__body": `ManualCodeModal_modal__body__OfCtT`,
	"modal__label": `ManualCodeModal_modal__label__grWBh`,
	"modal__input": `ManualCodeModal_modal__input__hnf6h`,
	"modal__footer": `ManualCodeModal_modal__footer__Xfxx8`,
	"modal__error": `ManualCodeModal_modal__error__kB07m`,
	"inputFocused": `ManualCodeModal_inputFocused__pOBya`
};
export default ___CSS_LOADER_EXPORT___;
